(() => {
  const setup = () => {
    const bars = Array.from(document.querySelectorAll('[data-rb-shipping-progress]'));
    if (!bars.length) return;

    let requestNumber = 0;
    const money = (cents) =>
      new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);

    const update = (cart) => {
      const lines = Array.isArray(cart.items) ? cart.items : [];
      const isAustralian = bars[0].dataset.rbCountry === 'AU' && cart.currency === 'AUD';
      const eligibleLines = lines.every((item) => {
        const type = String(item.product_type || '').toLowerCase();
        return !/shirt|hoodie|apparel|merch|print|gift.?card/.test(type)
          && !item.gift_card && !item.selling_plan_allocation;
      });
      const visible = isAustralian && cart.item_count > 0 && eligibleLines && !!cart.requires_shipping;
      const total = Number(cart.total_price || 0);
      const target = total >= 7000 ? 12000 : 7000;
      const remaining = Math.max(0, target - total);
      const progress = Math.max(0, Math.min(100, Math.round((total / target) * 100)));

      let message;
      if (total < 7000) {
        message = money(remaining) + ' until free standard shipping on eligible AU orders';
      } else if (total < 12000) {
        message = 'Free standard shipping threshold reached · ' + money(remaining) + ' to free express';
      } else {
        message = 'Free express shipping threshold reached';
      }
      for (const bar of bars) {
        bar.hidden = !visible;
        if (!visible) continue;
        const label = bar.querySelector('.rb-browse-progress__message');
        const track = bar.querySelector('.rb-browse-progress__track');
        const fill = bar.querySelector('.rb-browse-progress__fill');
        if (label && label.textContent.trim() !== message) label.textContent = message;
        if (track) track.setAttribute('aria-valuenow', String(progress));
        if (fill) fill.style.width = progress + '%';
      }
    };

    const refresh = async () => {
      const thisRequest = ++requestNumber;
      try {
        const path = (window.routes && window.routes.cart_url) || '/cart';
        const res = await fetch(path + '.js', { cache: 'no-store', credentials: 'same-origin' });
        if (!res.ok) return;
        const cart = await res.json();
        if (thisRequest !== requestNumber) return;
        update(cart);
      } catch (_) {
        // Keep the last verified state rather than display an invented cart amount.
      }
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    }

    const notification = document.getElementById('cart-notification');
    if (notification && typeof MutationObserver !== 'undefined') {
      const observer = new MutationObserver(() => {
        if (notification.classList.contains('active')) refresh();
      });
      observer.observe(notification, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('pageshow', refresh);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    refresh();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }
})();